<template>
  <div class="leagues-container">
    <el-row>
      <el-button type="primary" @click="newMatch" >添加联赛</el-button>
    </el-row>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        width="120"
        align="center"
        prop="seq">
        <template slot="header" slot-scope="scope">
          <div>排序</div>
          <el-input
            v-model="search.seq"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot="header" slot-scope="scope">
          <div>联赛名称</div>
          <el-input
            v-model="search.name"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
        <template slot-scope="scope">
          <bjh-link :to="getEditRouter(scope.row)">{{scope.row.name}}</bjh-link>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatType"
        width="120"
        prop="type">
        <template slot="header" slot-scope="scope">
          <div>比赛类型</div>
          <el-select v-model="search.type" @change="quickSearch" placeholder="请选择" clearable>
            <el-option
            v-for="(item, i) in typeStrs"
            :key="i"
            :label="item"
            :value="i"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatLevel"
        width="120"
        prop="level">
        <template slot="header" slot-scope="scope">
          <div>级别</div>
          <el-select v-model="search.level" @change="quickSearch" placeholder="请选择" clearable>
            <el-option
            v-for="(item, i) in levelStrs"
            :key="i"
            :label="item"
            :value="i"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        width="120"
        align="center"
        label="组别数量"
        prop="groupCount">
      </el-table-column>
      <el-table-column
        :formatter="formatDate"
        width="160"
        prop="createDate">
        <template slot="header" slot-scope="scope">
          <div>创建时间</div>
          <el-date-picker
            v-model="search.createDate"
            @change="quickSearch"
            type="date"
            placeholder="选择日期" />
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatState"
        width="120"
        prop="status">
        <template slot="header" slot-scope="scope">
          <div>状态</div>
          <el-select v-model="search.status" @change="quickSearch" placeholder="请选择">
            <el-option
              v-for="item in stateList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="250"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="goGroups(scope.row.id)">管理组别</el-button>
          <el-button
            size="mini"
            @click="goReferees(scope.row.id)">裁判统计</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment'
import find from 'lodash/find'
import { getMatchList, matchStateList, deleteMatch } from '@/api/match'

export default {
  name: 'LeagueList',
  data() {
    return {
      search: {},
      list: [],
      totalCount: 0, // 默认数据总数
      pageSize: 20, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      listLoading: true,
      stateList: [],
      typeStrs:["标准比赛", "小场地"],
      levelStrs:["国际", "国家", "市级", "区级"]
    }
  },
  created() {
    this.getList()
    this.getStateList()
  },
  computed: {
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    newMatch() {
      this.$router.push({ name: 'LeagueEdit'})
    },
    getEditRouter(row) {
      return {path:`details/${row.id}`}
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该联赛, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteMatch(this.list[index].id)
      }).catch(() => {
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    getList() {
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      if (this.search.createDate) {
        this.search.createDate = moment(this.search.createDate).format('YYYY-MM-DD')
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      getMatchList(this.listQuery).then(response => {
        const data = response.data
        this.list = data.list
        this.currentPage = data.pageNum
        this.totalCount = data.count
        this.listLoading = false
      })
    },
    deleteMatch(userId) {
      const params = {
        id: userId,
        status: -2
      }
      deleteMatch(params).then(response => {
        const data = response.data
        if (data) {
          this.$message({
            message: '删除成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    getStateList() {
      this.stateList = matchStateList
    },
    formatState: function(row, column) {
      const value = row[column.property]
      const obj = find(this.stateList, function(item) {
        return item.value === value
      })
      return obj && obj.label
    },
    formatDate: function(row, column) {
      const date = row[column.property]
      return date && moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    formatType: function(row, column) {
      return this.typeStrs[row[column.property]]
    },
    formatLevel: function(row, column) {
      return this.levelStrs[row[column.property]]
    },
    goGroups(id) {
      this.$router.push({
        name: 'LeagueGroups',
        params: {
          id: id
        }
      })
    },
    goReferees(id) {
      this.$router.push({
        name: 'LeagueReferees',
        params: {
          id: id
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .leagues-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
      th>{
        .cell {
          text-overflow: clip;
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }

    .el-date-editor.el-input {
      width: 140px;
    }

    .el-input__prefix {
      left: 10px
    }

    .el-input__suffix {
      right: 10px;
    }

    .el-input--prefix .el-input__inner {
      padding-left: 25px;
      padding-right: 20px;
    }

    .demonstration {
      display: block;
      padding-bottom: 15px;
    }

    .input-win {
      width: 200px !important;
    }

    .input-win .el-input__prefix {
      left: 5px;
    }

    .el-button--text {
      color: #606266
    }
    .el-button--text:hover {
      color: #409EFF;
      text-decoration: underline;
    }
    .el-button+.el-button {
      margin-left: 0;
    }

  }
</style>
